
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ajustHeight } from "@/shared/dom.utils";
import { UserDocument } from "@/interfaces/user.interfaces"

@Component
export default class SAccUsersList extends Vue {
  // Les props
  @Prop({default: []})private users!: UserDocument[]
  @Prop({default: ''}) private search!: string
  @Prop({default: false}) private loading!: boolean

  // Les propriétés
  private height: string = '400px'

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }

  private get filteredUsers() {
    if (this.search) {
      return this.users.filter(u => `${u.firstname} ${u.lastname}`.toLowerCase().search(this.search.toLowerCase()) !== -1)
    } else {
      return this.users
    }
  }

  // Les hooks
  public mounted() {
    window.addEventListener('resize', this.ajustHeight)
    this.$nextTick(this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  private ajustHeight() {
    this.height = `${ajustHeight('vsusrlist', 70)}px`
  }

  private onSelected(item: UserDocument) {
    this.$emit('user', item)
  }

  // Les méthodes statiques
  private icon = (item: UserDocument) => {
    const lettre = item.capacity.substring(0,1)
    return `mdi-alpha-${lettre}-circle`
  }

}
